import { getColorScheme } from "@appally/lib/utils/colorSchemes";
import { selectAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(selectAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    rounded: "lg",
  },
  _dark: {
      color: "white",
      bg: "black.700",
    },
  icon: {
    _dark: {
      color: "white",
    },
  },
});

export const Select = defineMultiStyleConfig({
  baseStyle,
  variants: {
    solid: (props) => {
      const { main, light, dark, text, tint } = getColorScheme(
        props.colorScheme,
      );
      return {
        field: {
          border: "1px solid",
          borderColor: "black.600",

          color: dark,
          bg: "white",
          _hover: {
            borderColor: main,
          },
          _focus: {
            bg: tint,
            borderColor: main,
          },
          _disabled: {
            color: light,
          },
          _focusVisible: {
            borderColor: main,
          },
          _dark: {
            color: light,
            bg: "black.700",
            _hover: {
              borderColor: dark,
            },
            _focus: {
              borderColor: dark,
              bg: "black.700",
            },
            _focusVisible: {
              borderColor: dark,
            },
          },
        },
        icon: {
          color: "black.800",

          _dark: {
            color: "white",
          },
        },
      };
    },
  },
  defaultProps: {
    size: "md",
    colorScheme: "primary",
    variant: "solid",
  },
});
